// Query key factory for consistent cache keys across the app
export const queryKeys = {
  // Admin
  dashboard: ['dashboard'] as const,
  clients: {
    all: ['clients'] as const,
    list: (params?: Record<string, unknown>) => ['clients', 'list', params] as const,
    detail: (id: number) => ['clients', 'detail', id] as const,
  },
  audits: {
    all: ['audits'] as const,
    list: (params?: Record<string, unknown>) => ['audits', 'list', params] as const,
    detail: (id: number) => ['audits', 'detail', id] as const,
  },
  proposals: {
    detail: (id: number) => ['proposals', 'detail', id] as const,
  },
  projects: {
    all: ['projects'] as const,
    list: (params?: Record<string, unknown>) => ['projects', 'list', params] as const,
    detail: (id: number) => ['projects', 'detail', id] as const,
  },
  storage: {
    all: ['storage'] as const,
    list: (prefix?: string) => ['storage', 'list', prefix] as const,
  },
  team: ['team'] as const,
  settings: ['settings'] as const,
  invoices: {
    all: ['invoices'] as const,
    settings: ['invoices', 'settings'] as const,
  },

  // Portal
  portal: {
    dashboard: ['portal', 'dashboard'] as const,
    projects: ['portal', 'projects'] as const,
    project: (id: number) => ['portal', 'project', id] as const,
    proposal: (id: number) => ['portal', 'proposal', id] as const,
    payments: ['portal', 'payments'] as const,
    notifications: ['portal', 'notifications'] as const,
    checkoutConfig: ['portal', 'checkoutConfig'] as const,
    sessionStatus: (sessionId: string) => ['portal', 'sessionStatus', sessionId] as const,
  },
};
